import { Navigate, Outlet } from "react-router-dom";
import BuyerSidebar from "./BuyerSidebar";

function BuyerLayout() {
  const user = JSON.parse(localStorage.getItem("user"));

  if (!user || user.role !== "buyer") {
    return <Navigate to="/login" />;
  }

  return (
    <div className="lg:flex">
      <BuyerSidebar />

      <div className="flex-1 lg:p-6 bg-gray-100 min-h-screen">
        <Outlet />
      </div>
    </div>
  );
}

export default BuyerLayout;